<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Asociar ROC-GES</span
            >
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <div>
            
            <form
                class="form"
                [formGroup]="formulario"
                autocomplete="off"
                class="mt-16"
            >
                <mat-form-field class="full-width">
                    <mat-label>Nro. ROC-HES </mat-label>
                    <input
                        matInput
                        type="text"
                        formControlName="numero"
                        required
                    />
                    <mat-error *ngIf="numero.hasError('required')">
                        Debe ingresar el nro. Roc-Ges
                    </mat-error>
                    <mat-error *ngIf="numero.hasError('maxlength')">
                        El valor del Roc-Ges no puede exceder los 20 caracteres
                    </mat-error>
                </mat-form-field>

                <!-- mat-form-field class="full-width">
                    <mat-label>Informe </mat-label>
                    <ngx-mat-file-input
                        placeholder="Seleccione un archivo"
                        formControlName="informe"
                    >
                    </ngx-mat-file-input>

                    <mat-error *ngIf="informe.errors?.maxSize">
                        El documento no puede ser mayor a {{ maxSize }} MB
                    </mat-error>
                </mat-form-field -->
                <!-- mat-form-field class="full-width" -->
                <div *ngIf="blob" class="file-uploader">
                    <button
                    mat-icon-button
                    type="button"
                    color="accent"
                    (click)="bajarInforme()"
                    aria-label="Adjuntar archivo"
                    [@animate]="{
                        value: '*',
                        params: { delay: '300ms', scale: '0.2' }
                    }">
                    <mat-icon>cloud_download</mat-icon> Descargar
                </button>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button
                mat-button
                (click)="blob=null;tieneAdjunto=false;"
                aria-label="Adjuntar archivo"
            >
                <mat-icon color="warn">delete_forever</mat-icon> Borrar
            </button>

                </div>
                
                <div *ngIf="!blob" class="file-uploader">
                    <input
                        hidden
                        type="file"
                        #fileInput
                        formControlName="informe"
                        (change)="getFile($event.target.files)"
                    />
                    <button
                        mat-button
                        *ngIf="informe && !informe.value"
                        color="primary"
                        class="add-file-button"
                        (click)="fileInput.click()"
                        aria-label="Adjuntar archivo"
                        [@animate]="{
                            value: '*',
                            params: { delay: '300ms', scale: '0.2' }
                        }"
                    >
                        <mat-icon>note_add</mat-icon>
                        Adjuntar archivo
                    </button>

                    <button
                        mat-button
                        *ngIf="informe && informe.value"
                        (click)="informe.setValue(null);tieneAdjunto=false;"
                        aria-label="Adjuntar archivo"
                        [@animate]="{
                            value: '*',
                            params: { delay: '300ms', scale: '0.2' }
                        }"
                    >
                        <small>{{ informe.value }}</small>
                        <mat-icon color="warn">delete_forever</mat-icon>
                    </button>
                    <mat-error *ngIf="informe.errors?.error_file_size">
                        El documento no puede ser mayor a 2 MB
                    </mat-error>
                </div>
                <!-- /mat-form-field -->
            </form>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>

        <button
            *ngIf="esSupervisor"
            mat-raised-button
            color="accent"
            (click)="cerrar()"
            [disabled]="!formulario.valid || !tieneAdjunto"
        >
            Guardar
        </button>

        <button
            *ngIf="!esSupervisor"
            mat-raised-button
            color="accent"
            (click)="cerrar()"
            [disabled]="!formulario.valid"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>


